import { on } from 'events';
import { atomWithStorage } from 'jotai/utils';
import { atom } from 'jotai/vanilla';

const onboardFinished = atomWithStorage('onboardConnectedAccountFinished',false);

export const getUpdateOnboardProcess = atom(
    (get) => get(onboardFinished),
    (get, set, onboardFinishedStatus) => {
        set(onboardFinished, onboardFinishedStatus)
    }
)
